import { typedMemo } from '@utils';
import { TooltipOnEllipsis } from './TooltipOnEllipsis';

interface TooltipHeaderRendererProps {
  displayName: string;
}
export const TooltipHeaderRenderer = typedMemo(
  ({ displayName }: Readonly<TooltipHeaderRendererProps>) => {
    return (
      <TooltipOnEllipsis title={displayName}>{displayName}</TooltipOnEllipsis>
    );
  },
);
